import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'nbx-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CardComponent {
  @Input() size = "medium";
  @Input() status = "basic";
  @Input() accent = "basic";
  @Input() header = "Form Header";
  @Input() showh = true;
}